import { HashRouter, Route, Routes } from "react-router-dom"
import Home from "./Home"
import Empty from "./Empty"
const Router = () => {
    return <HashRouter>
        <Routes>
            <Route path="/:id" element={<Home />}></Route>
            <Route path="/" element={<Home />}></Route>
            {/* <Route path="/" element={<Empty />}></Route> */}
        </Routes>
    </HashRouter>
}
export default Router